$(document).ready(function () {
  // The date after which the logo should be changed
  const targetDate = new Date('2025-01-01T00:00:00');
  // The current date
  const currentDate = new Date();
  function changeLogoVariable(variableName, newLogoUrl) {
    document.documentElement.style.setProperty(
      variableName,
      `url('${newLogoUrl}')`
    );
  }
  if (currentDate >= targetDate) {
    changeLogoVariable('--logo-header', '../svg/hg-logo.svg');
    changeLogoVariable('--logo-burger', '../svg/hg-logo-mobile.svg');
  } else {
    changeLogoVariable('--logo-header', '../svg/hg-anniversary-logo.svg');
    changeLogoVariable(
      '--logo-burger',
      '../svg/hg-anniversary-logo-mobile.svg'
    );
  }
});
